export default function downloadFile(file: Blob, fileName: string): void {
  const aElement = document.createElement('a');
  aElement.setAttribute('download', fileName.replaceAll('"', ''));
  const href = URL.createObjectURL(file);
  aElement.href = href;
  aElement.setAttribute('target', '_blank');
  aElement.click();
  URL.revokeObjectURL(href);
}
